var readUrlParam = function(name){
  try{
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    return decodeURI(results[1]) || 0;
  }catch(err){
    console.error(`Cannot read URL param ${name}`,err);
  }
};

/**
 * Service
 * @folder Services
 * @class
 */
class DebugService {

  /**
   * Renvoie l'instance du service
   * @returns {Service} singleton instance
   */
  static getInstance() {
    if (!DebugService._instance) {
      DebugService._instance = new DebugService();
    }
    return DebugService._instance;
  }

  constructor(store) {
    this.enabled = false; // par defaut le debug n'est pas actif

    this.readEnabled();
  }

  /**
   * Check if the debug is enabled.
   * Depends on .env config REACT_APP_DEBUG_MODE:
   * * REACT_APP_DEBUG_MODE=true Active
   * * REACT_APP_DEBUG_MODE=urlparam Active if URL param ?debug=true
   * * REACT_APP_DEBUG_MODE=false No debug
   * @params {function} cb callback, take boolean as param, true if debug is up, false otherwise
   */
  readEnabled() {
    const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE;
    // console.log('DebugService - readEnabled',{DEBUG_MODE});  // commente pour pas qu'il apparaisse si false

    if (DEBUG_MODE === true || DEBUG_MODE.toLowerCase() === 'true'){
      console.log('DebugService - Set debug true.');
      this.enabled = true;
      return;
    }
    if (DEBUG_MODE.toLowerCase() === 'urlparam'){
      const debugParam = readUrlParam('debug');
      const DEBUG = !!debugParam && (debugParam === true || debugParam.toLowerCase() === 'true');
      if (DEBUG) console.log('DebugService - readEnabled',{DEBUG});
      this.enabled = DEBUG;
    }
    else {
      this.enabled = false;
    }
  }

}

DebugService._instance = null;

export default DebugService;
